const configCafe = {
    cafe: {
        listLayout: 'CafeListDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        filterLayout: 'CafeFilterDefaultLayout',
        getFunc: 'getCafe',
        listApiParamSet: {
            ip: 1,
            ty: 'justreet',
            open: 1,
            fi: 1
        },
        paginationType: 'pagination',
        pageRow: 10,
    },
    update: {
        getFunc: 'getCafe',
        detailApiParamSet: {
            ip: 0,
            ty:'justreet',
            lo:1,
            tag:1,
            mc:1,
            ve:1,
            po:1,
            open:1,
        },
        subFunc: 'updateCafe',
        optionLayouts : ['CafeInputLayout'],
        parsingData: {
            memo: 'c_memo',
            hashList : 'ch_hash',
        },
        createApiParamSet: {
            c_type:'justreet',

        },
        validateAlertText:'필수정보를 확인해 주세요.',
        resultAlertTxt: '카페정보가 수정되었습니다.',
        directUrl: '',
        fileType:'cafe_logo',
    },
    openRequest:{
        listLayout: 'CafeListRequestLayout',
        paginationLayout: 'PaginationDefaultLayout',
        filterLayout: 'CafeFilterRequestLayout',
        getFunc: 'getCafe',
        listApiParamSet: {
            ip: 1,
            ty: 'justreet',
            open: 2,
            fi: 1
        },
        paginationType: 'pagination',
        pageRow: 10,
    },
    requestUpdate:{
        getFunc: 'getCafe',
        detailApiParamSet: {
            ip: 0,
            ty:'justreet',
            lo:1,
            tag:1,
            open:2,
        },
        optionLayouts : ['CafeInputRequestLayout'],
        parsingData: {
            memo: 'c_memo',
            hashList : 'ch_hash',
        },
        createApiParamSet: {
            c_type:'justreet',
        },
        fileType: 'cafe_logo',
        allowFunc: 'updateCafeAllow',
        allowApiParamsSet: {c_type: 'justreet'},
    },
    getMember:{
        listLayout: 'CafeListMemberLayout',
        paginationLayout: 'PaginationDefaultLayout',
        filterLayout: 'CafeFilterMemberLayout',
        getFunc: 'getCafeMember',
        listApiParamSet: {
            ip: 1,
            ty: 'justreet',
        },
        paginationType: 'pagination',
        pageRow: 10,
    },
    noLayout: {
        getFunc: 'getCafe',
        detailApiParamSet: {
            ip: 0,
            ty:'justreet',
            lo:1,
            tag:1,
            mc:1,
            ve:1,
            po:1,
            open:1,
        },
        subFunc: 'updateCafe',
        optionLayouts : ['CafeHiddenLayout'],
        parsingData: {
            memo: 'c_memo',
            hashList : 'ch_hash',
        },
        createApiParamSet: {
            c_type:'justreet',

        },
        validateAlertText:'필수정보를 확인해 주세요.',
        resultAlertTxt: '카페정보가 수정되었습니다.',
        directUrl: '',
        fileType:'cafe_logo',
    },
}
export default {
    methods: {
        returnCafeConfig(type) {
            return configCafe[type];
        }
    },
    filterConfig: {
        na: {
            type: 'query',
            classname: 'searchInput',
        },
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        op: {
            type: 'between',
            classname: 'filterDate',
        },
        ap: {
            type: 'between',
            classname: 'filterDate',
        },
        se: {
            type: 'match',
            classname: 'filterShow',
        },
        st: {
            type: 'match',
            classname: 'filterStatus',
        }
    }
}
